import { InboxDelivery } from 'app/core/models';

export class InboxHelper {
  static filterFavorite(list: InboxDelivery[], showOnlyFavorite: boolean) {
    if (showOnlyFavorite) {
      return list.filter((listItem: InboxDelivery) => listItem.favourite);
    }

    return list;
  }
}
